import { TicketStage } from '../../services/hubspot/ticket-stage.ts';

const ticketStagesMessages: Record<TicketStage, string> = {
  [TicketStage.CLOSED]: 'Gesloten',
  [TicketStage.NEW]: 'Nieuw',
  [TicketStage.WAITING_ON_CONTACT]: 'In afwachting van uw reactie',
  [TicketStage.WAITING_ON_US]: 'In behandeling',
};

export const TicketMessages = {
  title: 'Ticket',
  create: 'Nieuw ticket aanmaken',
  display: 'Ticket {hs_ticket_id} - {subject}',
  noAssociatedContacts: 'Er zijn geen contacten gekoppeld.',
  noAssociatedDeals: 'Er zijn geen orders gekoppeld.',
  operationalSupportOnlyNotice:
    'Gebruik tickets alleen voor technische ondersteuning bij bestaande orders.',
  contactOtherQuestionsNotice: 'Neem contact op met onze verkoop- of administratieafdeling voor andere vragen.',

  search: 'Zoek op ticketnummer of -naam',

  properties: {
    content: 'Beschrijving',
    createDate: 'Aanmaakdatum',
    id: 'Ticketnummer',
    owner: 'Behandelaar',
    priority: 'Prioriteit (SLA)',
    stage: 'Status',
    subject: 'Naam',
  },

  attachments: 'Bijlagen',
  noAttachments: 'Geen bijlagen.',

  note: {
    body: 'Bericht',
    create: 'Notitie toevoegen',
    none: 'Er zijn nog geen notities geplaatst.',
    list: 'Notities',
  },
  stages: ticketStagesMessages,
};
